<div class="main-content" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800 assessments">Assessments <i [popover]="assessmentsHelp" class="fas fa-question-circle pointer"></i></h1>
                    <popover-content #assessmentsHelp
                                     title="Assessments"
                                     placement="right"
                                     [animation]="true"
                                     [closeOnClickOutside]="true">
                        <p>See the activity of your assessments here. Use the tab to the right to create an action for your assessments. You can learn more about this feature in Tutorial 6.</p>
                    </popover-content>
                </div>


                <ng-container *ngIf="_Globals.showCompletedAssessments">

                    <div *ngIf="loading" class="text-center" style="position: absolute;width: 99.8%;height: 100%;background-color: #fff;z-index: 3;min-height:300px;">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;margin-top: 30px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <div>
                    <form id="shopifyForm" action="https://community.ipeccoaching.com/sso-eli-shopify/" method="post" enctype="multipart/form-data">
                        <input type="text" name="contact_id" value="" hidden>
                        <input type="email" name="user_email" value="" hidden>
                        <input type="text" name="first_name" value="" hidden>
                        <input type="text" name="last_name" value="" hidden>
                        <!--<input type="submit" value="SSO-Redirect" (click)="ssoToShopify()">-->
                    </form>
                </div>

                <div class="quickMenu">
                    <div class="dropdown">
                        <a class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" data-toggle="dropdown">
                            <span class="button-text"> Actions </span> <i class="fas fa-caret-down" style="vertical-align: unset;"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <!--<li><a (click)="getUserPersonalData()">Purchase assessments</a></li>-->
                            <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-self-assessment-1&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase Self assessments</a></li>
                            <li><a href="https://ipec-single-sign-on.azurewebsites.net/api/saml/initiate-login?state=https://market.ipeccoaching.com/products/eli-360-assessment&code=8_haf_FvYLDXB1EDpw9MZF9vsLIs3yU2YISFLmXPJvUaAzFux01Cbw==" target="_blank">Purchase 360 assessments</a></li>
                            <li><a (click)="openAssignModal()">Assign assessments</a></li>
                        </ul>
                    </div>
                </div>

                <div class="topSpacingAssigned">
                    <div class="responsiveTabs">
                        <select id="responsiveSelect" #t (change)="openTab(t.value)">
                            <!--<option value="0-Tab1">Available</option>-->
                            <option value="2-Tab2">Assigned</option>
                            <option value="3-Tab3">Completed</option>
                            <option value="4-Tab4">Expired</option>
                            <option value="5-Tab5">Archived</option>
                        </select>
                    </div>

                    <div class="desktopTabs">
                        <ul class="tab-nav">
                            <!--<li (click)="loadTabContent(0)" class="active"><a data-toggle="tab" href="#assessmentsComponentTab1">Available</a></li>-->
                            <li (click)="loadTabContent(2)" class="active"><a data-toggle="tab" href="#assessmentsComponentTab2">Assigned</a></li>
                            <li (click)="loadTabContent(3)" id="completedAssessmentsTab"><a data-toggle="tab" href="#assessmentsComponentTab3">Completed</a></li>
                            <li (click)="loadTabContent(4)"><a data-toggle="tab" href="#assessmentsComponentTab4">Expired</a></li>
                            <li (click)="loadTabContent(5)"><a data-toggle="tab" href="#assessmentsComponentTab5">Archived</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content assessmentsComponent">
                        <!--<div id="assessmentsComponentTab1" class="tab-pane fade in active">
                <app-unassigned-assessments></app-unassigned-assessments>
            </div>-->

                        <div id="assessmentsComponentTab2" class="tab-pane fade  in active">
                            <app-assigned></app-assigned>
                        </div>

                        <div id="assessmentsComponentTab3" class="tab-pane fade">
                            <app-completed-assessments></app-completed-assessments>
                        </div>

                        <div id="assessmentsComponentTab4" class="tab-pane fade">
                            <app-expired></app-expired>
                        </div>

                        <div id="assessmentsComponentTab5" class="tab-pane fade">
                            <app-archived-assessments></app-archived-assessments>
                        </div>
                    </div>
                </div>

                <!--</div>-->
            </div>
        </div>
    </div>
</div>

<!--QUICK ACTIONS-->
<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assessment-modal #assignAssessment></app-assign-assessment-modal>